import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

class Subscribe extends React.Component {
	constructor( props ) {
		super( props )
	}

	componentDidMount() {

	}

	render() {
		return (
			<div className="wide-section-newsletter wide-section">
				<div className="-inner">
					<div className="-envelope">
						<div className="-paper">
							<h4>Enter your email and we’ll keep in touch.</h4>

							<form action="https://asn.us13.list-manage.com/subscribe?u=18d77efd9a7c64b0d80a5bf74&id=4dc08a507d" method="post" target="_blank">
								<input placeholder="Your Email" type="text" name="EMAIL" className="required" id="mce-EMAIL" />

								<button className="button -send" name="subscribe" id="mc-embedded-subscribe">Subscribe</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Subscribe )



// WEBPACK FOOTER //
// ./components/subscribe/subscribe.jsx